firebird.controller('callstatsQualityFeedbackCtrl', [
    '$rootScope',
    '$scope',
    'analyticsWrapperService',
    'logService',
    'helperService',
    'attendeeService',
    'meetingAPIService',
    'meetingService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        analyticsWrapperService,
        logService,
        helperService,
        attendeeService,
        meetingAPIService,
        meetingService,
        localizationService
    ) {
        const logger = logService.createLoggerWithSource('callstatsQualityFeedbackCtrl');
        var self = this;

        self.modalState = 'closed';
        self.modalTitle = localizationService.translate('LOBBY_PAGE.SURVEY.HOW_WAS_AUDIO_QUALITY');
        self.currentStep = 'audio';

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;

        self.audioQualityFeedback = audioQualityFeedback;
        self.videoQualityFeedback = videoQualityFeedback;

        self.audioScore = 5;
        self.videoScore = 5;
        self.comment = '';

        self.callbackFunction = undefined;

        self.close = close;
        self.init = init;
        self.submit = submit;

        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);

        self.init();

        ////////////////////////

        function init() {
            self.audioScore = 5;
            self.videoScore = 5;
            self.comment = '';
            self.currentStep = 'audio';
            self.modalTitle = localizationService.translate('LOBBY_PAGE.SURVEY.HOW_WAS_AUDIO_QUALITY');
        }

        function audioQualityFeedback(audioQualityScore) {
            self.audioScore = audioQualityScore;
            //The UI uses a star rating element where if you click on the right hand side of the 5th start
            //it is activating a 6th unseen star and giving you score of 6
            if (self.audioScore > 5) {
                logger.log('audio score reported above 5, downcasting score to 5');
                self.audioScore = 5;
            }
            self.currentStep = 'video';
            self.modalTitle = localizationService.translate('LOBBY_PAGE.SURVEY.HOW_WAS_VIDEO_QUALITY');
            digest();
        }

        function videoQualityFeedback(videoQualityScore) {
            self.videoScore = videoQualityScore;
            //The UI uses a star rating element where if you click on the right hand side of the 5th start
            //it is activating a 6th unseen star and giving you score of 6
            if (self.videoScore > 5) {
                logger.log('video score reported above 5, downcasting score to 5');
                self.videoScore = 5;
            }

            if (self.videoScore < 4 || self.audioScore < 4) {
                self.currentStep = 'comment';
                self.modalTitle = localizationService.translate('LOBBY_PAGE.SURVEY.SORRY_TO_HEAR_THAT');
            } else {
                self.currentStep = 'finished';
                self.modalTitle = localizationService.translate('LOBBY_PAGE.SURVEY.THANK_YOU');
            }

            digest();
        }

        function close() {
            logger.log('user closed the callstatsQualityFeedback');

            $rootScope.$broadcast('callstat-survey-completed');

            if (self.callbackFunction) {
                self.callbackFunction();
            }
            self.onHideModal(null, 'callstatsQualityFeedback');
        }

        function onShowModal(e, modalName, func) {
            if (modalName === 'callstatsQualityFeedback') {
                if (func && typeof func === 'function') {
                    self.callbackFunction = func;
                }
                self.init();
                self.modalState = 'open';
                digest();
            }
        }

        function onHideModal(e, modalName) {
            if (modalName === 'callstatsQualityFeedback') {
                self.modalState = 'closed';
            }

            digest();
        }

        function submit() {
            var overallScore = Math.floor((parseInt(self.audioScore) + parseInt(self.videoScore)) / 2);

            var feedback = {
                meetingCode: meetingService.getMeetingCode(),
                attendantId: attendeeService.getAttendantId(),
                overall: overallScore,
                audio: parseInt(self.audioScore),
                video: parseInt(self.videoScore),
                comment: self.comment
            };

            analyticsWrapperService.eventTrack('Post-Meeting Audio rating submitted', { gradeAnswer: self.audioScore });
            analyticsWrapperService.eventTrack('Post-Meeting Video rating submitted', { gradeAnswer: self.videoScore });

            meetingAPIService
                .sendAVQualityFeedback(feedback)
                .catch(function (e) {
                    // error already logged in the sendAVQualityFeedback function
                })
                .finally(function () {
                    self.close();
                });

            attendeeService.setCompletedCallstatSurvey(true);
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
